import React from "react";
import {EventHandler, NO_OP} from "../../constants/common";
import Input from './Input';
import {camelize} from "../../utils/stringUtils";
import {Label} from "../Label";

type NameInputProps = {
    name: string | null,
    label: string,
    className?: string,
    maxLength?: number,
    readOnly?: boolean,
    required?: boolean,
    onChange?: EventHandler,
    error?: string | null,
    hasInteractions?: boolean,
    whenUserHasInteracted?: () => void,
    forceShowErrors?: boolean,
    disabled?: boolean,
    placeholder?: string,
    autoComplete?: string,
    inputName?: string,
    inputId?: string,
}
export const Name: React.FC<NameInputProps> = ({
                                                   name,
                                                   className = "",
                                                   label,
                                                   readOnly = false,
                                                   required = true,
                                                   maxLength = 255,
                                                   onChange = NO_OP,
                                                   error,
                                                   hasInteractions,
                                                   whenUserHasInteracted,
                                                   forceShowErrors,
                                                   disabled = false,
                                                   placeholder,
                                                   autoComplete,
                                                   inputName,
                                                   inputId,
                                               }) => {
    const camelized = camelize(label);
    const labelId = `${camelized}-label`;
    const resolvedInputId = inputId ?? `${camelized}Input`;
    const resolvedInputName = inputName ?? camelized;
    const errorsWillBeShown = !!error && (forceShowErrors || hasInteractions);
    return (
        <div className={"name-input"}>
            <div className={`parent ${className}`} style={{marginBottom: '8px'}}>
                {/*<Label label={label} required={required} htmlFor={inputId} labelId={labelId}/>*/}
                <Label label={label} required={required} htmlFor={resolvedInputId} labelId={labelId}/>
                <Input
                    name={resolvedInputName}
                    id={resolvedInputId}
                    data-test-id="name-input-id"
                    className={`${camelized}Field profileDetails`}
                    // name={camelized}
                    aria-label={camelized}
                    aria-labelledby={labelId}
                    error={errorsWillBeShown ? error : undefined}
                    // id={inputId}
                    onChange={onChange}
                    onBlur={whenUserHasInteracted}
                    removeMarginTop
                    readOnly={readOnly}
                    size="medium"
                    type="text"
                    value={name || ""}
                    maxLength={maxLength}
                    disabled={disabled}
                    placeholder={placeholder}
                    autoComplete={autoComplete}
                />
            </div>
        </div>
    );
}
